<template>
  <c-box>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Gula Darah Sewaktu
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Gula Darah Sewaktu"
          height="62px"
          v-model="value.bloodSugar"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Gula Darah Sewaktu
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Standar Gula Darah Sewaktu"
          height="62px"
          v-model="value.bloodSugarStandard"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Gula Darah Sewaktu
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.bloodSugarConclusion"
          placeholder="Masukan Kesimpulan Gula Darah Sewaktu"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Total Kolesterol
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="text"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Total Kolesterol"
          height="62px"
          v-model="value.colestrol"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Total Kolesterol
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="text"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Standar Total Kolesterol"
          height="62px"
          v-model="value.colestrolStandard"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Kolesterol HDL
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Kolesterol HDL"
          height="62px"
          v-model="value.colestrolHDL"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Total Kolesterol
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.colestrolConclusion"
          placeholder="Masukan Kesimpulan Total Kolesterol"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Kolesterol HDL
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Standar Kolesterol HDL"
          height="62px"
          v-model="value.colestrolHDLStandard"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Kolesterol HDL
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.colestrolHDLConclusion"
          placeholder="Masukan Kesimpulan Kolesterol HDL"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Kolesterol LDL
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Kolesterol LDL"
          height="62px"
          v-model="value.colestrolLDL"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Kolesterol LDL
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Standar Kolesterol LDL"
          height="62px"
          v-model="value.colestrolLDLStandard"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Kolesterol LDL
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.colestrolLDLConclusion"
          placeholder="Masukan Kesimpulan Kolesterol LDL"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nilai Pengukuran Asam Urat
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Nilai Pengukuran Asam Urat"
          height="62px"
          v-model="value.uricAcid"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Standar Asam Urat
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="number"
          min="0"
          error-border-color="red.300"
          placeholder="Masukkan Standar Asam Urat"
          height="62px"
          v-model="value.uricAcidStandard"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Kesimpulan Asam Urat
      </c-form-label>
      <c-input-group size="md">
        <c-select
          v-model="value.uricAcidConclusion"
          placeholder="Masukan Kesimpulan Asam Urat"
          height="62px"
        >
          <option value="Rendah">Rendah</option>
          <option value="Normal">Normal</option>
          <option value="Tinggi">Tinggi</option>
          <option value="Sangat Tinggi">Sangat Tinggi</option>
        </c-select>
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Nutrition-Focused Physical Findings
      </c-form-label>
      <textarea
        rows="8"
        placeholder="Masukkan Nutrition-Focused Physical Findings"
        v-chakra="{
          border: '1px solid #C4C4C4',
          padding: '18px',
          width: '100%',
          borderRadius: '6px',
          height: '180px',
          '&:focus, &:focus-visible': {
            outline: 'unset',
          },
        }"
        v-model="value.nutritionFocusedPhysicalFinding"
      ></textarea>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Client History
      </c-form-label>
      <textarea
        rows="8"
        placeholder="Masukkan Client History"
        v-chakra="{
          border: '1px solid #C4C4C4',
          padding: '18px',
          width: '100%',
          borderRadius: '6px',
          height: '180px',
          '&:focus, &:focus-visible': {
            outline: 'unset',
          },
        }"
        v-model="value.clientHistory"
      ></textarea>
    </c-form-control>
    <c-flex
      v-for="(item, index) in value.others"
      :key="'others' + index"
      gap="6"
      mt="33px"
      mb="18px"
    >
      <c-form-control flex-grow="1">
        <c-form-label
          fontSize="14px"
          color="#555555"
          fontWeigh="400"
          fontFamily="Roboto"
        >
          Nama Field
        </c-form-label>
        <c-input-group size="md">
          <c-input
            type="text"
            error-border-color="red.300"
            placeholder="Masukkan Nama Field"
            height="62px"
            v-model="item.field"
          />
        </c-input-group>
      </c-form-control>
      <c-form-control flex-grow="1">
        <c-form-label
          fontSize="14px"
          color="#555555"
          fontWeigh="400"
          fontFamily="Roboto"
        >
          Value Field
        </c-form-label>
        <c-input-group size="md">
          <c-input
            type="text"
            error-border-color="red.300"
            placeholder="Masukkan Value Field"
            height="62px"
            v-model="item.value"
          />
        </c-input-group>
      </c-form-control>
      <c-button
        min-width="auto"
        variant-color="red"
        variant="link"
        @click="value.others.splice(index, 1)"
      >
        <c-image :src="require('@/assets/icon-trash-line.svg')" alt="empty" />
      </c-button>
    </c-flex>
    <c-button
      variant-color="brand"
      variant="outline"
      borderRadius="60px"
      h="62px"
      w="100%"
      left-icon="add"
      mb="25px"
      @click="addOther"
    >
      Tambah Lainnya
    </c-button>
  </c-box>
</template>

<script>
export default {
  name: "BiochemicalDataForm",
  props: ["value"],
  methods: {
    addOther() {
      this.value.others.push({
        field: "",
        value: "",
      })
    },
  },
}
</script>